module.exports = __webpack_public_path__ + "static/media/greenhouse2Step5-3.b52ab0d6.jpg";